"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ErrorReason_1 = require("../models/ErrorReason");
const logPromise_1 = __importDefault(require("../util/logPromise"));
const FetchHelper = {
    fetch: async (input, init) => {
        var _a;
        return (0, logPromise_1.default)(`"${(_a = init === null || init === void 0 ? void 0 : init.method) !== null && _a !== void 0 ? _a : 'Fetch'}" ${input instanceof Request ? input.url : input}`, fetchInternal(input, init));
    },
    json: (input, json, init) => FetchHelper.fetch(input, Object.assign(Object.assign({}, init), { headers: Object.assign(Object.assign({}, init === null || init === void 0 ? void 0 : init.headers), { 'Content-Type': 'application/json' }), body: JSON.stringify(json) })),
    async firebaseAuthorization(user) {
        if (!user) {
            throw new Error('Not authenticated');
        }
        const token = await user.getIdToken();
        return { Authorization: `Bearer ${token}` };
    },
};
async function fetchInternal(input, init) {
    const response = await fetch(input, init);
    if (response.status < 200 || response.status >= 300) {
        const json = await response.json();
        if (json.reason) {
            throw new ErrorReason_1.ErrorWithReason(json.message, json.reason, response.status);
        }
        throw new Error(`Bad status ${response.status} ${response.statusText}`);
    }
    return response;
}
exports.default = FetchHelper;
